module.exports = __webpack_public_path__ + "static/media/question.753a8732.png";